import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'tableSort'
})
export class TableSortPipe implements PipeTransform {
	constructor() {}

	transform(data: Array<Object>, order: boolean, field: string): Array<Object> {
		if (!data.length) {
			return data;
		}
		if (data.length <= 1) {
			return data;
		}
		return order
			? this.sortAscending(data, field)
			: this.sortDescending(data, field);
	}

	sortAscending(data: Array<Object>, field: string): Array<Object> {
		return data.sort((a: Object, b: Object): number => {
			if (typeof a[field] === 'string') {
				return a[field].localeCompare(b[field]);
			}
			if (typeof a[field] === 'number') {
				return a[field] - b[field];
			}

			return 0;
		});
	}

	sortDescending(data: Array<Object>, field: string): Array<Object> {
		return data.sort((a: Object, b: Object): number => {
			if (typeof b[field] === 'string') {
				return b[field].localeCompare(a[field]);
			}
			if (typeof b[field] === 'number') {
				return b[field] - a[field];
			}
			return 0;
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/pipes/table-sort/table-sort.pipe.ts